(() => {
  const mountId = 'outpacker-header-language';
  const wrapperSelector = '[id^="gt-wrapper-"], .gt_switcher_wrapper';
  let observer;
  let languageWidget;
  let queued = false;

  const languageOrder = ['en', 'de', 'es', 'fr', 'it', 'nl'];

  const orderLanguageOptions = (widget) => {
    const optionList = widget.querySelector('.gt_option');
    if (!optionList) return;

    const links = Array.from(optionList.querySelectorAll(':scope > a'));
    if (links.length < 2) return;

    const languageCode = (link) =>
      (link.dataset.gtLang || link.getAttribute('data-gt-lang') || '').toLowerCase();
    const desired = [...links].sort((a, b) => {
      const aCode = languageCode(a);
      const bCode = languageCode(b);
      const aIndex = languageOrder.includes(aCode) ? languageOrder.indexOf(aCode) : languageOrder.length - 1;
      const bIndex = languageOrder.includes(bCode) ? languageOrder.indexOf(bCode) : languageOrder.length - 1;
      return aIndex - bIndex;
    });

    if (links.every((link, index) => link === desired[index])) return;
    desired.forEach((link) => optionList.appendChild(link));
  };

  const normalizePosition = (widget) => {
    const floatingWrapper = widget.matches('.gt_switcher_wrapper')
      ? widget
      : widget.querySelector('.gt_switcher_wrapper');
    if (!floatingWrapper) return;

    floatingWrapper.style.removeProperty('position');
    floatingWrapper.style.removeProperty('top');
    floatingWrapper.style.removeProperty('right');
    floatingWrapper.style.removeProperty('bottom');
    floatingWrapper.style.removeProperty('left');
    floatingWrapper.style.removeProperty('z-index');
  };

  const relocate = () => {
    queued = false;

    const mount = document.getElementById(mountId);
    if (!mount) return false;

    const widget =
      (languageWidget?.isConnected && languageWidget) ||
      Array.from(document.querySelectorAll(wrapperSelector)).find(
        (candidate) =>
          candidate.closest(`#${mountId}`) ||
          candidate.matches('.gt_switcher_wrapper') ||
          candidate.querySelector('.gt_switcher')
      );

    if (!widget) return false;

    languageWidget = widget;

    if (widget.parentElement !== mount) {
      mount.appendChild(widget);
    }

    normalizePosition(widget);
    orderLanguageOptions(widget);
    mount.dataset.gtranslateMounted = 'true';
    return true;
  };

  const queueRelocation = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(relocate);
  };

  const start = () => {
    relocate();

    observer = new MutationObserver(queueRelocation);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('shopify:section:load', queueRelocation);
    document.addEventListener('shopify:section:reorder', queueRelocation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
